import React, { useEffect, useRef, useState } from "react";
import up from "../../assets/images/chevronUp.svg";
import down from "../../assets/images/chevronDown.svg";
import { useTranslation } from "react-i18next";
import { Divider } from "../Divider";
import "./CommonFilter.scss";
import { BrandedLinkButton } from "../Buttons";

export const CommonFilter = ({
  filterDetailsArray,
  className,
  panelWidth = "300px",
  applyFilterClick,
  resetFilterClick,
  filterHeader
}) => {
  const { t } = useTranslation(["labels", "errors"]);
  const [visible, setVisible] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 420);
  const panelRef = useRef(null);

  const handleToggle = () => {
    setVisible((prev) => !prev);
  };

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 420);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (!visible) return;
    const handleClickOutside = (event) => {
      if (panelRef.current && !panelRef.current.contains(event.target)) {
        setVisible(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [visible]);

  return filterDetailsArray?.length ? (
    <div
      className={`common-booking-filter-wrapper ${className ? className : ""}`}
      ref={panelRef}
    >
      <div
        className={`common-booking-filter ${visible ? "active" : ""}`}
        onClick={handleToggle}
      >
        <label className="filter-label">{t("COMMON.FILTERS")}</label>
        <img src={visible ? up : down} className="chev-icon" alt="chev-icon" />
      </div>

      <div
        className={`filter-row-panel  ${visible ? "open" : ""}`}
        style={{ width: isMobile ? "250px" : panelWidth }}
      >
        <div className="filter-header">
          <label className="filter-header-label">
            {filterHeader || ''}
          </label>
          <BrandedLinkButton
            label={t("COMMON.RESET_FILTER")}
            onClick={() => {
              resetFilterClick?.();
            }}
          />
        </div>
        {filterDetailsArray?.map((filterDetail, index) => {
          const isFirst = index === 0;
          return (
            <React.Fragment key={`key-${index}`}>
              <div
                className={`checkbox-row l-checkbox ${isFirst ? "pt-0" : ""}`}
              >
                <label
                  htmlFor={`filter-option_${filterDetail.label}`}
                  className="checkbox-label"
                >
                  {t(`${filterDetail.label}`)}
                </label>
                <input
                  id={`filter-option_${filterDetail.label}`}
                  checked={filterDetail.isChecked}
                  type="checkbox"
                  onChange={(e) => filterDetail?.onChange(e)}
                />
                <label
                  htmlFor={`filter-option_${filterDetail.label}`}
                  className="checkbox-label"
                />
              </div>
              <Divider width={"93%"} />
            </React.Fragment>
          );
        })}
        <div className="apply-filter-wrapper">
          <BrandedLinkButton
            label={t("COMMON.APPLY_FILTER")}
            onClick={() => {
              applyFilterClick?.();
              handleToggle();
            }}

          />
        </div>
      </div>
    </div>
  ) : (
    <></>
  );
};
